import React, {useEffect, useMemo, useState} from 'react'
import 'react-quill/dist/quill.snow.css'
import makeAnimated from 'react-select/animated'
import {ScrollTop} from '../../../../../_metronic/layout/components/scroll-top'
import ScrollToTop from '../../../../componet/scrollTop'
import {isValidLanguages} from '../../../../utils/isAllow'
import * as Yup from 'yup'
import {Advancedschema} from '../../../../yup/ProductsShcema'
import GeneralApi from '../../../../Api/SettingGeneral'

import {InputController} from '../componnet/inputController'
import {InputCurtom} from '../componnet/inputCurtom'
import {tabsItem} from '../tabs'
import {InitialValues} from '../validationSchema'
import {useTranslation} from 'react-i18next'
import {Box, Stack, Typography} from '@mui/material'
import {InputCurtomWithLabel} from '../componnet/CustomInput'
import {useParams} from 'react-router-dom'
import {RootState} from '../../../../store'
import {useSelector} from 'react-redux'
import MainBtn from '../../../customTable/MainBtn'
import ValidationFun from '../../../../yup/ValidationFun'
import OldInput from '../../../customTable/OldInput'
import MasgsError from '../../../customTable/MasgsError'
import PopUp from '../../../customTable/PopUp'
import InputType from '../../../customTable/InputType'
import RedStart from '../../../customTable/RedStart'
import {useDispatch} from 'react-redux'
import {actions} from '../../../../store/vender/Auth/auth.slice'
import ErrorMsg from '../../../customTable/NewMsgErr'
const animatedComponents = makeAnimated()
type Props = {
  formik: any
  setActiveKey: React.Dispatch<React.SetStateAction<string>>
  setActive: React.Dispatch<React.SetStateAction<number>>
}

export const Advanced = (props: any) => {
  const {formik, setActiveKey, setActive, setErrors, errors} = props
  const {id} = useParams()
  const [languages, setlanguages] = useState(['en'])
  const store = useSelector((state: RootState) => state.vender)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setlanguages(store.storeLangs)
  }, [store.storeLangs])
  const dispatch = useDispatch()

  const [open, setOpen] = useState(false)
  const handelNext = async () => {
    if (id) {
      ValidationFun(
        {
          ...formik.values,
          height: formik.values.height || 0,
          length: formik.values.length || 0,
          weight: formik.values.weight || 0,
          width: formik.values.width || 0,
        },
        Advancedschema(languages),
        setErrors,
        () => {
          setMsgErr('')
          setActive(7)
          setActiveKey('Links')
        }
      )
    } else {
      ValidationFun(formik.values, Advancedschema(languages), setErrors, () => {
        setMsgErr('')
        setActive(3)
        setActiveKey('Links')
      })
      // Advancedschema(languages)
      //   .validate(formik.values)
      //   .then((value: any) => {
      //     setMsgErr('')
      //     setActive(3)
      //     setActiveKey('Links')
      //   })
      //   .catch((error: Yup.ValidationError) => {
      //     setMsgErr(error.message)
      //   })
    }

    // setActiveKey('Links')
  }
  const [msgErr, setMsgErr] = useState('')
  const {t} = useTranslation()
  const currency = localStorage.getItem('currency')
  const {sizeImages} = useSelector((state: any) => state.vender)
  const [sku, setSku] = useState('')
  const [data, setData] = useState<any>({})
  return (
    <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-6'>
      <div className='card card-flush py-4 mb-4'>
        {/* //<!--begin::Card header--> */}
        <div className='card-header'>
          <div className='card-title'>
            <h2>{t('inventory')}</h2>
          </div>
        </div>

        <div className='card-body pt-0'>
          {/* //<!--begin::Input group--> */}
          <div className='mb-10 fv-row'>
            <label className='required form-label'>{t('sku')}</label>
            <Stack flexWrap={{xs: 'wrap', lg: 'nowrap'}} gap='15px' direction={'row'}>
              <Stack
                border='1px solid var(--bs-gray-300)'
                borderRadius={'0.625rem'}
                direction={'row'}
                minWidth={'200px'}
                width={{xs: '100%', lg: '78%'}}
              >
                {sizeImages.default_sku || sku ? (
                  <Stack
                    minWidth={'120px'}
                    p='5px 15px'
                    justifyContent={'center'}
                    borderRadius={'0.475rem !important'}
                    alignItems={'center'}
                    bgcolor='var(--bs-gray-300)'
                  >
                    {sizeImages.default_sku || sku}
                  </Stack>
                ) : (
                  <MainBtn handelSubmit={() => setOpen(true)} text='addSku' height='100%' />
                )}

                <OldInput
                  notMsgErr
                  withoutBorder
                  formik={formik}
                  errors={errors}
                  type='number'
                  name={'sku'}
                />

                {/* <ErrorMsg msgErr={msgErr} name='SKU' /> */}
              </Stack>
              <MainBtn
                height={'44.5px'}
                width='auto'
                without
                handelSubmit={() => {
                  //   GEATE sku RANDAM

                  formik.setFieldValue(`sku`, Math.floor(Math.random() * 10000000))
                }}
                text='generate'
              />
            </Stack>
            <ErrorMsg msgErr={errors['sku']} />

            {/*   div  with  sam  line  */}
          </div>
          <div
            style={{flexWrap: 'wrap'}}
            className='d-flex justify-content-between align-items-start  mb-2 gap-4 g-2'
          >
            <Stack sx={{width: {lg: '48%', xs: '100%'}}} className=' col-xl-6 fv-row '>
              <label className='required form-label'> {t('inStock')} </label>
              {/*  SELECT  WITH  JUST  YSES  OR  NOR */}
              <select
                className='form-select  form-select-lg fw-bold'
                {...formik.getFieldProps('in_stock')}
              >
                <option value='1'>{t('yes')}</option>
                <option value='0'>{t('no')}</option>
              </select>
            </Stack>
            {formik.values.in_stock == 1 && (
              <Stack sx={{width: {lg: '48%', xs: '100%'}}} className=' col-xl-6 fv-row '>
                <label className='required form-label'>{t('UNLIMITEDSTOCK')}</label>
                {/*  SELECT  WITH  JUST  YSES  OR  NOR */}
                <select
                  className='form-select  form-select-lg fw-bold'
                  {...formik.getFieldProps('unlimited_quantity')}
                >
                  <option value='1'>{t('yes')}</option>
                  <option value='0'>{t('no')}</option>
                </select>
              </Stack>
            )}
          </div>
          {formik.values.unlimited_quantity == 0 && formik.values.in_stock == 1 && (
            <div className='mb-10 mt-4'>
              {/* //<!--begin::Label--> */}
              <label className='form-label'> {t('quantity')} </label>
              {/* //<!--end::Label--> */}
              {/* //<!--begin::Input--> */}
              {/* <input
                type='number'
                {...formik.getFieldProps(`quantity`)}
                className='form-control mb-2'
                placeholder='Quantity'
              /> */}
              <OldInput formik={formik} errors={errors} type='number' name={'quantity'} />
            </div>
          )}
        </div>
      </div>

      <div className='card card-flush py-4 my-2'>
        {/* //<!--begin::Card header--> */}
        <div className='card-header'>
          <div style={{display: 'flex', gap: '20px'}} className='card-title'>
            <h2> {t('requiresShipping')} </h2>
            {/*   switch  */}
            <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                id='flexSwitchCheckDefault'
                checked={!!formik.values.is_shipping_pickup}
                {...formik.getFieldProps('is_shipping_pickup')}
                onChange={(e) => {
                  formik.setFieldValue(`is_shipping_pickup`, e.target.checked ? 1 : 0)
                }}
              />
            </div>
          </div>
          {/*  card  body  */}
        </div>
        {formik?.values?.is_shipping_pickup ? (
          <div className='card-body pt-0'>
            {[
              {
                unit: 'Kg',
                name: 'weight',
                label: t('weight'),
              },

              {
                unit: 'Cm',
                name: 'height',
                label: t('height'),
              },
              {
                unit: 'Cm',
                name: 'width',
                label: t('width'),
              },
              {
                unit: 'Cm',
                name: 'length',
                label: t('length'),
              },
            ].map((x) => {
              return (
                <>
                  <InputCurtomWithLabel
                    errors={errors}
                    key={x.name}
                    required={formik?.values?.is_shipping_pickup}
                    label={x?.label}
                    name={x?.name as keyof InitialValues}
                    unit={x?.unit}
                    formik={formik}
                  />
                </>
              )
            })}
          </div>
        ) : null}
      </div>

      {/*   proice   */}

      <div className='card card-flush py-2 my-2'>
        {/* //<!--begin::Card header--> */}
        <div className='card-header'>
          <div className='card-title'>
            <h2>{t('pricing')}</h2>
          </div>
        </div>
        <div className='card-body'>
          <InputCurtomWithLabel
            formik={formik}
            label={t('costPrice')}
            type={'number'}
            name={'cost'}
            // placeholder={'Cost Price'}
            required={false}
            unit={currency || '$'}
          />

          <InputCurtomWithLabel
            formik={formik}
            label={t('price')}
            type={'number'}
            errors={errors}
            name={'price'}
            // placeholder={'Cost Price'}
            required={true}
            unit={currency || '$'}
          />

          <InputCurtomWithLabel
            formik={formik}
            label={t('discountPrice')}
            type={'number'}
            name={'discount_amount'}
            errors={errors}
            // placeholder={'Cost Price'}
            required={false}
            unit={currency || '$'}
          />
        </div>
      </div>

      <div style={{gap: '20px'}} className='d-flex justify-content-end'>
        {errors && <MasgsError errors={errors} />}

        <button
          className='btn btn-light me-5'
          onClick={() => {
            setActiveKey('General')
          }}
        >
          {t('back')}
        </button>
        <MainBtn
          width='auto'
          handelSubmit={() => {
            if (sku || sizeImages.default_sku) {
              setErrors({...errors, newNku: null})
              console.log('sku', sku, sizeImages.default_sku)

              handelNext()
            } else {
              setErrors({...errors, newNku: 'defaultSkuErr'})
            }
          }}
          isLoading={formik.isSubmitting}
          text='next'
        />
      </div>
      <Stack alignItems={'flex-end'}></Stack>

      <PopUp width={'sm'} setOpen={setOpen} open={open}>
        <Stack p='24px' gap='15px'>
          <Stack direction={'row'} gap='5px'>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '16px',
                color: 'var(--bs-body-color)',
                lineHeight: '16px',
              }}
            >
              {t('sku')}
            </Typography>
            <RedStart />
          </Stack>
          <Box width='100%'>
            <InputType errors={errors} name={'newNku'} change={setData} value={data} type='text' />
          </Box>
          <MainBtn
            isLoading={isLoading}
            handelSubmit={() => {
              if (!data.newNku) {
                setErrors({...errors, newNku: 'defaultSkuErr'})
              } else {
                setErrors({...errors, newNku: null})
                console.log(data.newNku)

                GeneralApi.putSKU(
                  {default_sku: data.newNku},
                  (res: any) => {
                    dispatch(actions.setImagesSize({...sizeImages, default_sku: res.default_sku}))
                    setOpen(!true)
                  },
                  setIsLoading
                )
              }
            }}
            text='addSku'
          />
        </Stack>
      </PopUp>
      <ScrollToTop />
    </div>
  )
}
